<script setup lang="ts">
import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from '@/components/ui/form';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { vAutoAnimate } from '@formkit/auto-animate/vue';
import { Label } from '@/components/ui/label';
import { useForm } from 'vee-validate';
import { toTypedSchema } from '@vee-validate/zod';
import { z } from 'zod';
import axios from 'axios';
import { useRoute } from 'vue-router';
import { toast } from '@/components/ui/toast';
import { options } from '@/components/satisfaction/options';

const route = useRoute();

const props = defineProps<{
    type: string;
}>();

const emit = defineEmits<{
    (e: 'submitted'): void;
}>();

const typesLabels = {
    '1': 'Could you share what didn’t go well?',
    '2': 'Could you share what didn’t go well?',
    '3': 'Share your suggestions',
    '4': 'Share your suggestions',
}

const formSchema = toTypedSchema(z.object({
    text: z.string().trim().min(1, { message: 'Required' }),
}));

const { handleSubmit } = useForm({
    validationSchema: formSchema,
});

const onSubmit = handleSubmit(async (values) => {
    const comment = [
        {
            question: 'How was your experience so far?',
            key: 'experience',
            answer: options.find(option => option.value === props.type)?.label,
        },
        {
            question: typesLabels[props.type],
            key: 'text',
            answer: values.text,
        },
    ]
    const res = await axios.post('/setSatisfaction', {
        comment: JSON.stringify(comment),
        appID: route.query.appID,
    }) as any;
    if (res.status === 'success') { 
        emit('submitted');
    } else {
        toast({
            variant: 'destructive',
            title: 'Something went wrong. Please try again later.',
        });
    }
});
</script>

<template>
    <form @submit="onSubmit">
        <FormField v-slot="{ componentField }" name="text">
            <FormItem v-auto-animate>
                <FormControl>
                    <div class="grid gap-1.5">
                        <Label for="text" class="font-bold mb-2">{{ typesLabels[type] }}</Label>
                        <Textarea id="text" class="min-h-40" v-bind="componentField"/>
                    </div>
                </FormControl>
                <FormMessage />
            </FormItem>
        </FormField>
        <Button size="lg" class="mt-5 w-full">Submit</Button>
    </form>
</template>
